import { HttpErrorResponse } from '@angular/common/http';
import { List, Record, RecordOf } from 'immutable';



export type AuthError = RecordOf<AuthErrorProperties>;


export interface AuthErrorProperties {
  code: string;
  message: string;
  scope: string;
  params: List<any>;
}


export class AuthErrorFactory {

  static readonly create = Record<AuthErrorProperties>({
    code: null,
    message: null,
    scope: null,
    params: List<any>()
  });


  static fromJSON(errors: any[]): AuthError {
    if (Array.isArray(errors) && errors.length) {
      return AuthErrorFactory.create({
        code: errors[0].code || errors[0].id,
        message: errors[0].message,
        scope: errors[0].scope,
        params: Array.isArray(errors[0].params) ? List(errors[0].params) : List()
      });

      // const list = errors.map(error => {
      //   return AuthErrorFactory.create({
      //     code: error.code || error.id,
      //     description: error.description,
      //     message: error.description,
      //     scope: error.scope,
      //     params: Array.isArray(error.params) ? List(error.params) : List()
      //   });
      // });
      //
      // return List<AuthError>(list);
    }

    return null;
  }


  static fromResponse(response: HttpErrorResponse): AuthError {
    try {

      
      if (response.status >= 400 && response.status < 500) {
        const errors = JSON.parse(response.error);
        // return AuthErrorFactory.fromJSON(errors);
        if (Array.isArray(errors) && errors.length) {
          return AuthErrorFactory.create({
            code: errors[0].code,
            message: errors[0].message,
            scope: errors[0].scope,
            params: Array.isArray(errors[0].params) ? List(errors[0].params) : List()
          });
        }
      }

      return AuthErrorFactory.getUnknownError();
    }
    catch (e) {
      return AuthErrorFactory.getUnknownError();
    }
  }


  static getUnknownError(): AuthError {
    return AuthErrorFactory.create({code: '0'});
    // return List().push(AuthErrorFactory.create({code: '0'}));
  }

}
